<!-- Modificada por IAL | 2026-04-10 | Powered by ianossolutions.ai -->
<div class="modal-header border-0 pb-0">
  <div>
    <h5 class="modal-title fw-bold">Send Notification</h5>
    <p class="text-muted tx-13 mb-0">Select one or more templates to send</p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body pt-2">
  <div class="list-group list-group-flush">
    <label *ngFor="let notification of templateNotification"
      class="list-group-item list-group-item-action d-flex align-items-center gap-3 cursor-pointer py-3"
      [ngClass]="{'active-template': notification.selected}">
      <div class="form-check mb-0">
        <input class="form-check-input" type="checkbox"
          [checked]="notification.selected"
          (change)="toggleSelection(notification.uid)"
          [id]="'tpl-' + notification.uid">
      </div>
      <div class="flex-grow-1">
        <p class="mb-0 fw-semibold">{{ notification.title }}</p>
        <small class="text-muted" *ngIf="notification.body">{{ notification.body | slice:0:80 }}{{ notification.body?.length > 80 ? '…' : '' }}</small>
      </div>
      <i class="feather icon-check-circle text-primary fs-5" *ngIf="notification.selected"></i>
    </label>
  </div>

  <div *ngIf="templateNotification.length === 0" class="text-center py-4 text-muted">
    <i class="feather icon-mail" style="font-size:2rem"></i>
    <p class="mt-2 mb-0">No active templates available</p>
  </div>
</div>

<div class="modal-footer border-0">
  <span class="text-muted tx-13 me-auto" *ngIf="hasSelectedTemplates()">
    {{ getSelectedCount() }} template(s) selected
  </span>
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="sendNotifications()" [disabled]="!hasSelectedTemplates()">
    <i class="feather icon-send me-1"></i>Send
  </button>
</div>
